export default __webpack_public_path__ + "static/media/uniforme.7858185d.png";